module.exports = __webpack_public_path__ + "static/media/proactively-follows-up@3x.23ecc9ea.png";